import * as React from 'react';
import * as _ from 'lodash';
import { getLocation, WindowWrapper } from 'login-utils/globalWrappers';
import * as queryString from 'query-string';
import NotificationBar from './NotificationBar';

// WARNING: This is duplicated in the borrower app to ensure that snoozed warnings last across our apps.
const WARNING_KEY = 'nonProdWarningSnoozedAt';

class NonProdWarningBar extends React.Component<{}, {}> {
  dismissNotification = () => {
    WindowWrapper.sessionStorage.setItem(WARNING_KEY, Date.now().toString());

    // Need to forceUpdate here because we're storing it on the session and not on local state.
    this.forceUpdate();
  };

  render() {
    const parsedQuery = queryString.parse(getLocation());

    // There are multiple reasons we wouldn't show this notification bar.
    if (parsedQuery.disableNonProdWarning === 'true') {
      return null;
    }
    if (!_.includes(['uat'], WindowWrapper.NODE_ENV)) {
      return null;
    }

    const nonProdWarningSnoozeTime = parseInt(WindowWrapper.sessionStorage.getItem(WARNING_KEY) || '', 10);
    const tenMinutesMs = 1000 * 60 * 10;
    const tenMinutesAgo = Date.now() - tenMinutesMs;
    const snoozedMoreThanTenMinutes = nonProdWarningSnoozeTime && nonProdWarningSnoozeTime < tenMinutesAgo;
    if (!isNaN(nonProdWarningSnoozeTime) && !snoozedMoreThanTenMinutes) {
      return null;
    }

    return (
      <NotificationBar
        notificationText="This is a non-production environment. Do not enter confidential information (e.g. SSN)."
        dismissText="Snooze"
        onDismiss={this.dismissNotification}
      />
    );
  }
}

export default NonProdWarningBar;
